/**
 * ResizablePanels Component
 * 
 * Two-column layout with draggable divider
 */

import React from 'react'
import './ResizablePanels.css'

interface ResizablePanelsProps {
  leftPanel: React.ReactNode
  rightPanel: React.ReactNode
  leftWidth: number
  rightWidth: number
  onMouseDown: (e: React.MouseEvent) => void
  isDragging: boolean
  containerRef: React.RefObject<HTMLDivElement>
}

const ResizablePanels: React.FC<ResizablePanelsProps> = ({
  leftPanel,
  rightPanel,
  leftWidth,
  rightWidth,
  onMouseDown,
  isDragging,
  containerRef
}) => {
  return (
    <div 
      ref={containerRef}
      className="resizable-panels-container"
      style={{ display: 'flex', width: '100%', position: 'relative' }}
    >
      {/* Left Panel */}
      <div 
        className="resizable-panel-left"
        style={{ 
          width: `${leftWidth}%`,
          paddingRight: '8px',
          overflow: 'auto'
        }}
      >
        {leftPanel}
      </div>

      {/* Resize Handle */}
      <div 
        className={`resize-handle ${isDragging ? 'dragging' : ''}`}
        onMouseDown={onMouseDown}
        style={{
          width: '8px',
          cursor: 'col-resize',
          backgroundColor: isDragging ? '#007bff' : '#dee2e6',
          flexShrink: 0,
          position: 'relative',
          transition: isDragging ? 'none' : 'background-color 0.2s'
        }}
      >
        <div 
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '3px',
            height: '40px',
            borderLeft: '1px solid #6c757d',
            borderRight: '1px solid #6c757d',
            opacity: 0.5
          }}
        />
      </div>

      {/* Right Panel */}
      <div 
        className="resizable-panel-right"
        style={{ 
          width: `${rightWidth}%`,
          paddingLeft: '8px',
          overflow: 'auto'
        }}
      >
        {rightPanel}
      </div>
    </div>
  )
}

export default ResizablePanels

